export default __webpack_public_path__ + "static/media/4.e6a4e03b.jpg";